import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import './assets/css/tailwind.output.css'
import App from './App'
import { SidebarProvider } from './context/SidebarContext'
import { SnackbarProvider } from './context/SnackbarContext'
import { AuthProvider } from './context/AuthContext'
import { ChatProvider } from './hooks/useChat'
import ThemedSuspense from './components/ThemedSuspense'
import { Windmill } from '@windmill/react-ui'
import * as serviceWorker from './serviceWorker'
// Import PostHog
import posthog from './utils/posthog'
import { PostHogProvider } from 'posthog-js/react'

ReactDOM.render(
  <PostHogProvider client={posthog}>
    <SidebarProvider>
      <SnackbarProvider>
        <AuthProvider>
          <ChatProvider>
            <Suspense fallback={<ThemedSuspense />}>
              <Windmill theme="light">
                <App />
              </Windmill>
            </Suspense>
          </ChatProvider>
        </AuthProvider>
      </SnackbarProvider>
    </SidebarProvider>
  </PostHogProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
